import React, { createContext, useContext } from 'react';
export type ThemeType = 'ajman' | 'sharjah' | 'bahrain' | 'bahrain2' | 'dubai';
export interface ThemeConfig {
  logoUrl: string;
  orgNameAr: string;
  orgNameEn: string;
  attribution: string;
}
export const THEMES: Record<ThemeType, ThemeConfig> = {
  ajman: {
    logoUrl: 'https://cdn.magicpatterns.com/uploads/guuHfaZLt2Uy8cu6D838iS/TA.svg',
    orgNameAr: 'هيئة النقل — حكومة عجمان',
    orgNameEn: 'Ajman Transport Authority',
    attribution: 'مقدم إلى هيئة النقل — حكومة عجمان'
  },
  sharjah: {
    logoUrl: 'https://cdn.magicpatterns.com/uploads/h1CdXBYu7YXaym2o5dNDuV/image_68.png',
    orgNameAr: 'القيادة العامة لشرطة الشارقة',
    orgNameEn: 'Sharjah Police Headquarters',
    attribution: 'مقدم إلى القيادة العامة لشرطة الشارقة'
  },
  bahrain: {
    logoUrl: 'https://cdn.magicpatterns.com/uploads/aeoNdnfeBd34K4VuPipZ5S/GDT.jpg',
    orgNameAr: 'الإدارة العامة للمرور — مملكة البحرين',
    orgNameEn: 'General Directorate of Traffic — Kingdom of Bahrain',
    attribution: 'مقدم إلى الإدارة العامة للمرور — مملكة البحرين'
  },
  bahrain2: {
    logoUrl: 'https://cdn.magicpatterns.com/uploads/8rikZPhNwT6YE1CtjexLu1/mtt_bahrain_logo.jpg',
    orgNameAr: 'وزارة المواصلات والاتصالات — مملكة البحرين',
    orgNameEn: 'Ministry of Transportation and Telecommunications — Kingdom of Bahrain',
    attribution: 'مقدم إلى وزارة المواصلات والاتصالات — مملكة البحرين'
  },
  dubai: {
    logoUrl: 'https://cdn.magicpatterns.com/uploads/2ZQ37nHCHcTVWXGGAXtwie/Dubai-police-logo-vector.png',
    orgNameAr: 'القيادة العامة لشرطة دبي',
    orgNameEn: 'Dubai Police',
    attribution: 'مقدم إلى القيادة العامة لشرطة دبي'
  }
};
interface ThemeContextValue {
  theme: ThemeConfig;
  themeType: ThemeType;
}
const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);
export function ThemeProvider({
  themeType,
  children
}: {
  themeType: ThemeType;
  children: ReactNode;
}) {
  return <ThemeContext.Provider value={{
    theme: THEMES[themeType],
    themeType
  }} data-id="element-838">
      {children}
    </ThemeContext.Provider>;
}
export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}